module.exports = __webpack_public_path__ + "static/collaboration-8fd411c1ee615dcb0a1e3104d8e36976.jpeg";